var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgMouseClick = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.984 23.495c.148-.265.246-.369.514-.511l4.686-2.602-10.649-2.855 2.854 10.65 2.6-4.683h-.005zm2.681.683l4.582 4.583c.976.976-.507 2.46-1.487 1.487l-4.578-4.583-3.224 5.798c-.472.844-1.721.648-1.938-.275l-3.983-14.87c-.211-.784.515-1.487 1.283-1.282l14.907 3.996c.916.246 1.046 1.474.24 1.925l-5.798 3.224-.004-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.5,
    d: "M23.5 1C35.925 1 46 11.075 46 23.5S35.925 46 23.5 46 1 35.925 1 23.5 11.075 1 23.5 1zm0 2.097c-11.265 0-20.403 9.138-20.403 20.403 0 11.265 9.138 20.403 20.403 20.403 11.265 0 20.403-9.138 20.403-20.403 0-11.265-9.138-20.403-20.403-20.403z"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMouseClick, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mouse-click.29d86953.svg";
export { ForwardRef as ReactComponent };